import React, { Component } from 'react';
import Select from 'react-select';

export default class CustomSelectGroup extends Component {
  handleChange = values => {
    let value;
    if (values instanceof Array || this.props.isMulti) {
      value = values
        ? values.map(val => {
            return val.value;
          })
        : [];

      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    } else {
      value = values ? values.value : '';
      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    }
    this.props.onChange(this.props.name, value);
  };

  handleBlur = () => {
    this.props.onBlur([this.props.name], true);
  };

  render() {
    const { name, options, value, placeholder, isMulti } = this.props;
    let groupOptions = [];
    options.map(e => {
      groupOptions.push(...e.options);
    });
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: '#e3edff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#2684FF'
            : isFocused
            ? '#2684FF9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#e3edff' : '#2684FF'),
          },
        };
      },
    };

    let valuesList = null;
    if (isMulti) {
      valuesList = value ? groupOptions.filter(option => value.indexOf(option.value) >= 0) : [];
    } else {
      valuesList = groupOptions.find(option => option.value === value);
    }
    return (
      <Select
        name={name}
        isMulti={isMulti}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        value={valuesList}
        placeholder={placeholder}
        onChange={this.handleChange}
        styles={colourStyles}
        isClearable={true}
      />
    );
  }
}
